import { PropertyValues, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { PageView } from '@operato/shell'
import { i18next, localize } from '@operato/i18n'

import './data-sample-view.js'

@customElement('data-sample-page')
export class DataSampleViewPage extends localize(i18next)(PageView) {
  static styles = [
    css`
      :host {
        display: flex;
      }

      data-sample-view {
        flex: 1;
      }

      @media print {
        :host {
          display: block;
          overflow: visible;
        }
      }
    `
  ]

  @property({ type: Object }) dataSampleId?: any

  get context() {
    return {
      title: i18next.t('title.data-sample view'),
      help: 'dataset/data-sample',
      actions: []
    }
  }

  render() {
    return html` <data-sample-view .dataSampleId=${this.dataSampleId}></data-sample-view> `
  }

  updated(changes: PropertyValues<this>) {}

  pageUpdated(changes: any, lifecycle: any, before: any) {
    if (this.active) {
      /*
       * this page is activated
       */
      this.dataSampleId = lifecycle.resourceId
    } else {
      /* this page is deactivated */
    }
  }
}
